(function( $ ) {
	'use strict';

	/**
	 * All of the code for your admin-facing JavaScript source
	 * should reside in this file.
	 *
	 * Note: It has been assumed you will write jQuery code here, so the
	 * $ function reference has been prepared for usage within the scope
	 * of this function.
	 *
	 * This enables you to define handlers, for when the DOM is ready:
	 *
	 * $(function() {
	 *
	 * });
	 *
	 * When the window is loaded:
	 *
	 * $( window ).load(function() {
	 *
	 * });
	 *
	 * ...and/or other possibilities.
	 *
	 * Ideally, it is not considered best practise to attach more than a
	 * single DOM-ready or window-load handler for a particular page.
	 * Although scripts in the WordPress core, Plugins and Themes may be
	 * practising this, we should strive to set a better example in our own work.
	 */
	$( window ).on( 'load', function() {

		const required = $( 'input[required], select[required], textarea[required]' );
		required.each( function( index ) {
			if ( $( this ).find( '.icon-asterisk' ).length === 0 ) {
				$( this ).closest(".control-group")
				.children("label")
				.prepend("<i class='icon-asterisk'></i> ").append("<span class='required'> (Required) </span>");
			}
		} );
			

		const $shipping_choice = $( '#_shipping_method' );
		$( '.shipping-container' ).find('input[required]').addClass( 'isrequired' );
		maybe_hide_froptions( $shipping_choice.val() );
		$shipping_choice.on('change', function(ev){
			maybe_hide_froptions( $( this ).val() );
		});
		$( 'a.shipping' ).on('click', function(ev){
			maybe_hide_froptions( $shipping_choice.val() );
		});
		$( '.wcv_product_variations' ).on( 'click', 'h5.variation_title', function(ev){
			maybe_hide_froptions( $shipping_choice.val() );
		});
		$( '#wcv_variable_product_options' ).on( 'wcv_variations_input_changed', function(ev){
			maybe_hide_froptions( $shipping_choice.val() );
		});
		$( '#wcv_variable_product_options' ).on( 'wcv_variations_added', function(ev){
			maybe_hide_froptions( $shipping_choice.val() );
		});
		if ( $('#_shipping_fee_national_free').is(':checked')){
			$('#_shipping_fee_national').prop('disabled', true);
		}
		if ( $('#_shipping_fee_international_free').is(':checked')){
			$('#_shipping_fee_international').prop('disabled', true);
		}

		$('.wcv_featured_image_msg').hide();
		$('#wcv-product-edit').submit(function(e) {
			if ($('#_featured_image_id').val() === '') {
				$('.wcv_featured_image_msg').show();
			}
		});
		function local_pick_up_fields( main_field ) {
			if ( main_field.is(':checked') ) {
				$('#_mavenfair_local_pick_up_default').prop('disabled', false);
				$('#_mavenfair_local_pick_up_custom').prop('disabled', false);
				$('#_mavenfair_local_pick_up_custom_message').prop('disabled', false);
			} else {
				$('#_mavenfair_local_pick_up_default').prop('disabled', true);
				$('#_mavenfair_local_pick_up_custom').prop('disabled', true);
				$('#_mavenfair_local_pick_up_custom_message').prop('disabled', true);
			}	
		};
		local_pick_up_fields( $('#_mavenfair_local_pick_up') );

		$('#_mavenfair_local_pick_up').on('change', function(){
			local_pick_up_fields( $( this ) );
		});

		$('#_mavenfair_local_pick_up_default').on( 'change', function(){
			if ( $(this).is(':checked') ) {
				$('#_mavenfair_local_pick_up_custom').prop('checked', false);
				$('#_mavenfair_local_pick_up_custom_message').prop('disabled', true);
			} else {
				$('#_mavenfair_local_pick_up_custom').prop('checked', true);
				$('#_mavenfair_local_pick_up_custom_message').prop('disabled', false);
			}
		});

		$('#_mavenfair_local_pick_up_custom').on( 'change', function(){
			if ( $(this).is(':checked') ) {
				$('#_mavenfair_local_pick_up_default').prop('checked', false);
				$('#_mavenfair_local_pick_up_custom_message').prop('disabled', false);
			} else {
				$('#_mavenfair_local_pick_up_custom').prop('checked', true);
				$('#_mavenfair_local_pick_up_custom_message').prop('disabled', true);
			}
		});
	});

	function maybe_hide_froptions( value ){
		const flat_rate       = $( '.show_on_flat_rate' );
		const canada_post     = $( '.hide_on_flat_rate' );
		const flat_required   = flat_rate.find('input.isrequired');
		const canada_required = canada_post.find('input.isrequired');
		const variation_set   = $('.shipping-variations');
		if ( 'flat_rate' !== value ) {
			flat_required.attr('required', false);
			canada_required.attr('required', true);
			flat_rate.hide();
			canada_post.show();
			variation_set.show();
			return;
		}
		flat_required.attr('required', true);
		canada_required.attr('required', false);
		flat_rate.show();
		canada_post.hide();
		variation_set.hide();
	}

	/**
	 * Check if a node is blocked for processing.
	 *
	 * @param {JQuery Object} $node
	 * @return {bool} True if the DOM Element is UI Blocked, false if not.
	 */
	var is_blocked = function( $node ) {
		return $node.is( '.processing' ) || $node.parents( '.processing' ).length;
	};

	/**
	 * Block a node visually for processing.
	 *
	 * @param {JQuery Object} $node
	 */
	var block = function( $node ) {
		if ( ! is_blocked( $node ) ) {
			$node.addClass( 'processing' ).block( {
				message: null,
				overlayCSS: {
					background: '#fff',
					opacity: 0.6
				}
			} );
		}
	};

	/**
	 * Unblock a node after processing is complete.
	 *
	 * @param {JQuery Object} $node
	 */
	var unblock = function( $node ) {
		$node.removeClass( 'processing' ).unblock();
	};

	var update_cart_totals_div = function( html_str ) {
		$( '.cart_totals' ).replaceWith( html_str );
		$( document.body ).trigger( 'updated_cart_totals' );
	};

	/**
	 * Update the .woocommerce div with a string of html.
	 *
	 * @param {String} html_str The HTML string with which to replace the div.
	 * @param {bool} preserve_notices Should notices be kept? False by default.
	 */
	var update_wc_div = function( html_str ) {
		var $html       = $.parseHTML( html_str );
		var $shipping_method   = $( '.product_shipping', $html );
		$( '.product_shipping' ).replaceWith( $shipping_method );

	};

	/**
	 * Object to handle AJAX calls for cart shipping changes.
	 */
	var product_shipping = {
		/**
		 * Initialize event handlers and UI state.
		 */
		init: function() {
			if ( ! $( 'body' ).hasClass( 'single-product' )) {
				return false;
			}
			//this.cart                       = cart;
			this.toggle_shipping            = this.toggle_shipping.bind( this );

			this.shipping_calculator_submit = this.shipping_calculator_submit.bind( this );

			$( document ).on(
				'click',
				'.shipping-calculator-button',
				this.toggle_shipping
			);

			$( document ).on(
				'submit',
				'form.woocommerce-shipping-calculator',
				this.shipping_calculator_submit
			);

			$( '.shipping-calculator-form' ).hide();
		},

		/**
		 * Toggle Shipping Calculator panel
		 */
		toggle_shipping: function() {
			$( '.shipping-calculator-form' ).slideToggle( 'slow' );
			$( document.body ).trigger( 'country_to_state_changed' ); // Trigger select2 to load.
			return false;
		},

		/**
		 * Handles a shipping calculator form submit.
		 *
		 * @param {Object} evt The JQuery event.
		 */
		shipping_calculator_submit: function( evt ) {
			evt.preventDefault();

			var $form = $( evt.currentTarget );

			block( $( '.product_shipping' ) );
			block( $form );

			// Provide the submit button value because wc-form-handler expects it.
			$( '<input />' ).attr( 'type', 'hidden' )
							.attr( 'name', 'calc_shipping' )
							.attr( 'value', 'x' )
							.appendTo( $form );

			// Make call to actual form post URL.
			$.ajax( {
				type:     $form.attr( 'method' ),
				url:      window.location.href,
				data:     $form.serialize(),
				dataType: 'html',
				success:  function( response ) {
					update_wc_div( response );
				},
				complete: function() {
					unblock( $form );
					unblock( $( '.product_shipping' ) );
				}
			} );
		}
	};
	product_shipping.init( );

})( jQuery );

//# sourceMappingURL=../../source/_maps/js/frontend/mavenfair-shipping-calculations.js.map
